// Design System — SectionRow constants

// Width of the label column (title + description) on tablet and up.
export const SECTION_ROW_LABEL_WIDTH = 300;

// Heading elements the title may render as; h3 fits under a SectionTitle (h4-level bar).
export const SECTION_ROW_HEADING = { H2: 'h2', H3: 'h3', H4: 'h4', H5: 'h5', DIV: 'div' };
export const SECTION_ROW_HEADINGS = Object.values(SECTION_ROW_HEADING);
